// import api from '@/api'
// import * as types from './mutations-types'
// import { getSignature, getUserInfo, dealSignatrue } from '~/assets/js/util'
import {alertData} from './state';
import api from '@/api';
let ossTime = null;
export const setSidebar = function ({ commit }, data) {
  commit('SET_SIDEBAR', data)
}

// alert
export const setAlertData = function ({ commit }, data) {
  // 数据重置还原
  let alert = {
    ...alertData,
    ...data
  };
  commit('SET_ALERT_DATA', alert)
}
export const setAlertDataShow = function ({ commit }, data) {
  commit('SET_ALERT_DATA_SHOW', data)
}
export const setAlertDataConfirmLoadingShow = function ({ commit }, data) {
  commit('SET_ALERT_DATA_CONFIRM_LOADING_SHOW', data)
}
export const setAlertDataDeleteLoadingShow = function ({ commit }, data) {
  commit('SET_ALERT_DATA_DELETE_LOADING_SHOW', data)
}
export const setAlertDataType = function ({ commit }, data) {
  commit('SET_ALERT_DATA_TYPE', data)
}

// 设置导航
export const setNavbarAction = function ({ commit }, data) {
  commit('SET_NAVBAR_ACTION', data)
}
// 设置sidebarnum
export const setSidebarNum = function ({ commit }, data) {
  commit('set_SIDEBAR_NUM', data)
}

export const hasCoverletter = function ({ commit }, data) {
  commit('HAS_COVERLETTER', data);
}
// 获取oss参数
export const getOssToken = function ({ commit, dispatch }, data) {
  api.staticApi.get_oss_token({}).then(res => {
    if (res.code === 1000) {
      let { access_key_id, access_key_secret, expiration, request_id, security_token } = res.data;
      let updateOssOptions = {
        region: 'oss-cn-beijing',
        accessKeyId: access_key_id,
        accessKeySecret: access_key_secret,
        bucket: 'staging-wondercv-logo',
        stsToken: security_token
      };
      commit('updateOssOptions', updateOssOptions);
      //十分钟重新获取一次
      let ossTimeIndex = 10;
      ossTime = setInterval(() => {
        if (ossTimeIndex <= 0) {
          //清除定时器
          clearInterval(ossTime);
          //重新获取oss参数
          dispatch('getOssToken')
        }
        ossTimeIndex -= 1;
      }, 60 * 1000);
    } else {

    }
  })
}
